/* eslint-disable @typescript-eslint/no-explicit-any */
import { Modal, Button, Form } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';

import {
  GetUserConsentAgreementToken,
  SetUserConsentAgreementToken,
} from '../../services/ApiConsent';
import checkPurposeIsReadyToUse from '../../helpers/CheckPurposeIsReadyToUse';

import { SwitchKeyVault } from '../../model/consent.data-type';

export const OneTrustCredentialModal = (props: any) => {
  const [token, setToken] = useState<any>();
  const [backedUpToken, setBackedUpToken] = useState<any>();
  const { register, handleSubmit, watch, reset, getValues } = useForm();
  const resetCredentials = {
    clientId: '',
    secretId: '',
  };

  useEffect(() => {
    (async () => {
      try {
        const tokenRes = await GetUserConsentAgreementToken();

        if (tokenRes) {
          reset(tokenRes);
          setToken(tokenRes);
          setBackedUpToken(tokenRes);
        }

        console.log('token', token);
      } catch (error) {
        console.log(error);
      }
    })();
  }, [props?.showModal, reset]);

  const [disabledFields, setDisabledFields] = useState(false);
  const [requiredField, setRequiredField] = useState(false);

  useEffect(() => {
    (async () => {
      if (watch('status') == undefined) return;

      if (watch('status') == SwitchKeyVault.enable) {
        setDisabledFields(true);
        setRequiredField(false);

        reset(resetCredentials);
      } else {
        setDisabledFields(false);
        setRequiredField(true);

        const backedUpData = {
          ...backedUpToken,
          apiToken: getValues('apiToken'),
          status: SwitchKeyVault.disable,
        };

        reset(backedUpData);
        setToken(backedUpData);
      }
    })();
  }, [watch('status')]);

  const onSubmit = (data: any) => {
    (async () => {
      try {
        const purposeParam = props?.purposeToDelete || props?.purpose;

        const latestPurpose = props?.allPurposes?.find(
          (ap: any) => ap?.purposeId === purposeParam?.purposeId,
        );

        if (purposeParam && props?.requestToAutoTriggerPurpose) {
          const [isReady, reason] = await checkPurposeIsReadyToUse(
            { ...purposeParam, version: latestPurpose?.version },
            data?.apiToken,
          );

          if (!isReady) {
            Swal.fire({
              icon: 'warning',
              title: 'Warning!',
              text: 'Token is invalid!',
            });

            return;
          }
        }

        // if enable KeyVault
        if (data.status == SwitchKeyVault.enable) {
          data = {
            ...data,
            ...resetCredentials,
          };
        }

        await SetUserConsentAgreementToken(data);
        props?.setValidToAutoTriggerPurpose(true);

        toast.success('OneTrust credential is updated.', {
          position: 'top-right',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });

        props?.hideModal();
      } catch (error) {
        console.log(error);

        return Swal.fire({
          icon: 'error',
          title: 'Error!',
          text: 'Something went wrong! Please try again later!',
        });
      }
    })();
  };

  return (
    <Modal show={props?.showModal} onHide={props?.hideModal} keyboard={false}>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Modal.Header>
          <Modal.Title>OneTrust Credentials</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3" controlId="keyVault">
            <Form.Label>Key Vault</Form.Label>
            <br />
            <Form.Check
              inline
              label="Enable"
              type="radio"
              required
              value={SwitchKeyVault.enable}
              defaultChecked={
                token?.status === SwitchKeyVault.enable ? true : false
              }
              {...register(`status`)}
            />
            <Form.Check
              inline
              label="Disable"
              type="radio"
              required
              value={SwitchKeyVault.disable}
              defaultChecked={
                token?.status === SwitchKeyVault.disable ? true : false
              }
              {...register(`status`)}
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId="clientId">
            <Form.Label>Client ID</Form.Label>
            <Form.Control
              as="input"
              {...register('clientId')}
              defaultValue={token?.clientId}
              disabled={disabledFields}
              autoComplete="off"
              required={requiredField}
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId="secretId">
            <Form.Label>Secret ID</Form.Label>
            <Form.Control
              as="input"
              {...register('secretId')}
              defaultValue={token?.secretId}
              disabled={disabledFields}
              autoComplete="off"
              required={requiredField}
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId="token">
            <Form.Label>Token</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              {...register('apiToken')}
              defaultValue={token?.apiToken}
              autoComplete="off"
              required={true}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" onClick={props?.hideModal}>
            Cancel
          </Button>
          <Button variant="outline-success" type="submit">
            Submit
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};
